module.exports = __webpack_public_path__ + "static/media/md-card.37ae7a5d.svg";